var map = {
	"./ChildSafetyStandards": [
		9976,
		[
			976
		]
	],
	"./ChildSafetyStandards/": [
		9976,
		[
			976
		]
	],
	"./ChildSafetyStandards/index": [
		9976,
		[
			976
		]
	],
	"./ChildSafetyStandards/index.tsx": [
		9976,
		[
			976
		]
	],
	"./ContactUs": [
		7585,
		[
			585
		]
	],
	"./ContactUs/": [
		7585,
		[
			585
		]
	],
	"./ContactUs/index": [
		7585,
		[
			585
		]
	],
	"./ContactUs/index.tsx": [
		7585,
		[
			585
		]
	],
	"./Download": [
		3927,
		[
			927
		]
	],
	"./Download/": [
		3927,
		[
			927
		]
	],
	"./Download/index": [
		3927,
		[
			927
		]
	],
	"./Download/index.tsx": [
		3927,
		[
			927
		]
	],
	"./DownloadRedirect": [
		2526,
		[
			526
		]
	],
	"./DownloadRedirect/": [
		2526,
		[
			526
		]
	],
	"./DownloadRedirect/index": [
		2526,
		[
			526
		]
	],
	"./DownloadRedirect/index.tsx": [
		2526,
		[
			526
		]
	],
	"./Home": [
		8375,
		[
			375
		]
	],
	"./Home/": [
		8375,
		[
			375
		]
	],
	"./Home/index": [
		8375,
		[
			375
		]
	],
	"./Home/index.tsx": [
		8375,
		[
			375
		]
	],
	"./IndianDatingAustraliaBlog": [
		4012,
		[
			12
		]
	],
	"./IndianDatingAustraliaBlog/": [
		4012,
		[
			12
		]
	],
	"./IndianDatingAustraliaBlog/index": [
		4012,
		[
			12
		]
	],
	"./IndianDatingAustraliaBlog/index.tsx": [
		4012,
		[
			12
		]
	],
	"./IndianDatingCanadaBlog": [
		1616,
		[
			616
		]
	],
	"./IndianDatingCanadaBlog/": [
		1616,
		[
			616
		]
	],
	"./IndianDatingCanadaBlog/index": [
		1616,
		[
			616
		]
	],
	"./IndianDatingCanadaBlog/index.tsx": [
		1616,
		[
			616
		]
	],
	"./IndianDatingEuropeBlog": [
		5920,
		[
			920
		]
	],
	"./IndianDatingEuropeBlog/": [
		5920,
		[
			920
		]
	],
	"./IndianDatingEuropeBlog/index": [
		5920,
		[
			920
		]
	],
	"./IndianDatingEuropeBlog/index.tsx": [
		5920,
		[
			920
		]
	],
	"./IndianDatingUKBlog": [
		5482,
		[
			482
		]
	],
	"./IndianDatingUKBlog/": [
		5482,
		[
			482
		]
	],
	"./IndianDatingUKBlog/index": [
		5482,
		[
			482
		]
	],
	"./IndianDatingUKBlog/index.tsx": [
		5482,
		[
			482
		]
	],
	"./IndianDatingUSBlog": [
		7458,
		[
			458
		]
	],
	"./IndianDatingUSBlog/": [
		7458,
		[
			458
		]
	],
	"./IndianDatingUSBlog/index": [
		7458,
		[
			458
		]
	],
	"./IndianDatingUSBlog/index.tsx": [
		7458,
		[
			458
		]
	],
	"./NotFound": [
		6947,
		[
			947
		]
	],
	"./NotFound/": [
		6947,
		[
			947
		]
	],
	"./NotFound/index": [
		6947,
		[
			947
		]
	],
	"./NotFound/index.tsx": [
		6947,
		[
			947
		]
	],
	"./Privacy": [
		9062,
		[
			62
		]
	],
	"./Privacy/": [
		9062,
		[
			62
		]
	],
	"./Privacy/index": [
		9062,
		[
			62
		]
	],
	"./Privacy/index.tsx": [
		9062,
		[
			62
		]
	],
	"./Terms": [
		59,
		[
			59
		]
	],
	"./Terms/": [
		59,
		[
			59
		]
	],
	"./Terms/index": [
		59,
		[
			59
		]
	],
	"./Terms/index.tsx": [
		59,
		[
			59
		]
	]
};
function webpackAsyncContext(req) {
	try {
		if(!__webpack_require__.o(map, req)) {
			return Promise.resolve().then(() => {
	var e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
		}
	} catch(err) {
		return Promise.reject(err);
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__(id)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 629;
module.exports = webpackAsyncContext;